import { Group, Text, Stack, Anchor } from "@mantine/core";
import { IconFileText } from "@tabler/icons-react";
import dayjs from "dayjs";
import { DataTable } from "../DataTable";
import { TableActions, actionsColumn } from "../TableActions";

export default function DocumentsTable({
  data,
  page,
  limit,
  onPageChange,
  isPending,
}) {
  const columns = [
    {
      accessor: "fileName",
      title: "Filename",
      render: (row) => (
        <Group justify="space-between" wrap="nowrap">
          <Group gap="sm">
            <IconFileText size={16} color="blue" />
            <Text size="sm" fw={500}>
              {row.fileName}
            </Text>
          </Group>
        </Group>
      ),
    },
    {
      accessor: "assignedTo",
      title: "Assigned To",
      render: (row) => (
        <Group gap="xs">
          <Stack gap={0}>
            <Text size="sm">
              {row.userFirstName} {row.userLastName}
            </Text>
            <Text size="xs" c="dimmed">
              {row.userEmail}
            </Text>
          </Stack>
        </Group>
      ),
    },
    {
      accessor: "createdAt",
      title: "Created At",
      render: (row) => (
        <Text size="sm">
          {dayjs(row.createdAt).format("DD MMM YYYY, HH:mm")}
        </Text>
      ),
    },
    actionsColumn((row) => (
      <TableActions>
        <Anchor
          href={row.fileKey}
          target="_blank"
          rel="noopener noreferrer"
          style={{ whiteSpace: "nowrap", flexShrink: 0 }}
        >
          Download / View
        </Anchor>
      </TableActions>
    )),
  ];

  return (
    <DataTable
      columns={columns}
      records={data?.data}
      fetching={isPending}
      totalRecords={data?.pagination?.total}
      recordsPerPage={limit}
      page={page}
      onPageChange={onPageChange}
    />
  );
}
